import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-split",
  "use": "icon-op-split-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-split\"><path d=\"M7.6 6.9 3.7 3h2.8V2H2v4.5h1V3.7l3.9 3.9c.3.3.6 1 .6 1.4v5h1V9c0-.7-.4-1.6-.9-2.1M9.5 2v1h2.8L9 6.3c.2.3.4.6.5.9L13 3.7v2.8h1V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol